// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaSearch, FaSync, FaFileExport, FaCalendar, FaEye, FaChevronDown } from 'react-icons/fa';
// import { MdClose } from 'react-icons/md';
// import { useLoader } from '../../../../context/LoaderProvider';

// // ============================================
// // STYLES
// // ============================================
// const styles = {
//     container: {
//         margin: '0 auto',
//         height: "70vh",
//         scrollbarWidth: "thin",
//         overflow: "auto",
//         fontFamily: 'Segoe UI, sans-serif'
//     },
//     statsGrid: {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(4, 1fr)',
//         gap: '16px',
//         marginBottom: '10px'
//     },
//     statCard: {
//         background: 'white',
//         borderRadius: '12px',
//         padding: '20px 24px',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//         border: '1px solid #f0f0f0',
//         transition: 'all 0.3s ease'
//     },
//     statLabel: {
//         fontSize: '13px',
//         color: '#94a3b8',
//         fontWeight: '500',
//         marginBottom: '6px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px'
//     },
//     statValue: {
//         fontSize: '28px',
//         fontWeight: '700',
//         color: '#1e293b'
//     },
//     statSub: {
//         fontSize: '12px',
//         color: '#94a3b8',
//         marginTop: '4px'
//     },
//     filtersBar: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '12px',
//         background: 'white',
//         padding: '12px 20px',
//         borderRadius: '12px',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//         border: '1px solid #f0f0f0',
//         marginBottom: '10px',
//         flexWrap: 'wrap'
//     },
//     searchWrapper: {
//         display: 'flex',
//         alignItems: 'center',
//         flex: '1',
//         minWidth: '200px',
//         background: '#f8fafc',
//         borderRadius: '8px',
//         padding: '0 12px',
//         border: '1px solid #e2e8f0',
//         transition: 'all 0.2s ease'
//     },
//     searchInput: {
//         border: 'none',
//         background: 'transparent',
//         padding: '10px 8px',
//         fontSize: '14px',
//         outline: 'none',
//         flex: '1',
//         color: '#334155'
//     },
//     dateFilterBtn: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         padding: '10px 16px',
//         background: '#f8fafc',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         fontSize: '14px',
//         color: '#334155',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         minWidth: '140px',
//         whiteSpace: 'nowrap'
//     },
//     actionBtn: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         padding: '10px 18px',
//         border: 'none',
//         borderRadius: '8px',
//         fontSize: '14px',
//         fontWeight: '500',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease'
//     },
//     tableWrapper: {
//         background: 'white',
//         borderRadius: '12px',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
//         border: '1px solid #f0f0f0',
//         overflow: 'auto',
//         maxHeight: '70vh',
//         scrollbarWidth: 'thin'
//     },
//     table: {
//         width: '100%',
//         borderCollapse: 'collapse',
//         fontSize: '14px',
//         minWidth: '1100px'
//     },
//     th: {
//         background: '#f8fafc',
//         color: '#475569',
//         fontWeight: '600',
//         padding: '14px 16px',
//         textAlign: 'left',
//         borderBottom: '2px solid #e2e8f0',
//         position: 'sticky',
//         top: 0,
//         zIndex: 10,
//         background: '#f8fafc',
//         whiteSpace: 'nowrap'
//     },
//     td: {
//         padding: '14px 16px',
//         borderBottom: '1px solid #f1f5f9',
//         color: '#334155',
//         verticalAlign: 'middle'
//     },
//     viewButton: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         padding: '6px 14px',
//         background: '#2563eb',
//         color: 'white',
//         border: 'none',
//         borderRadius: '6px',
//         cursor: 'pointer',
//         fontSize: '12px',
//         fontWeight: '500',
//         transition: '0.2s'
//     },
//     rejectedByBadge: {
//         padding: '4px 12px',
//         borderRadius: '20px',
//         fontSize: '12px',
//         fontWeight: '600',
//         display: 'inline-block'
//     },
//     emptyState: {
//         textAlign: 'center',
//         padding: '60px 20px',
//         color: '#94a3b8'
//     },
//     loadingOverlay: {
//         textAlign: 'center',
//         padding: '40px 20px',
//         color: '#64748b'
//     },
//     dropdown: {
//         position: 'absolute',
//         top: 'calc(100% + 4px)',
//         left: 0,
//         background: 'white',
//         border: '1px solid #e2e8f0',
//         borderRadius: '12px',
//         boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
//         minWidth: '160px',
//         overflow: 'hidden',
//         zIndex: 100
//     },
//     dropdownItem: {
//         padding: '10px 18px',
//         fontSize: '14px',
//         cursor: 'pointer',
//         transition: 'all 0.15s ease',
//         color: '#334155'
//     },
//     modalOverlay: {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: 'rgba(0,0,0,0.5)',
//         backdropFilter: 'blur(4px)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         zIndex: 1000,
//         padding: '20px'
//     },
//     modalContent: {
//         background: 'white',
//         borderRadius: '16px',
//         padding: '32px',
//         maxWidth: '480px',
//         width: '100%',
//         boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
//     },
//     modalHeader: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: '24px'
//     },
//     modalTitle: {
//         fontSize: '20px',
//         fontWeight: '700',
//         color: '#1e293b'
//     },
//     modalClose: {
//         background: 'none',
//         border: 'none',
//         fontSize: '24px',
//         cursor: 'pointer',
//         color: '#94a3b8',
//         padding: '4px'
//     },
//     dateInputGroup: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: '6px'
//     },
//     dateLabel: {
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#475569'
//     },
//     dateInput: {
//         padding: '10px 14px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         fontSize: '14px',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         color: '#334155'
//     },
//     applyBtn: {
//         padding: '12px',
//         background: '#e66d33',
//         color: 'white',
//         border: 'none',
//         borderRadius: '8px',
//         fontSize: '16px',
//         fontWeight: '600',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         marginTop: '8px'
//     }
// };

// // ============================================
// // DUMMY DATA
// // ============================================
// const dummyOrders = [
//     {
//         id: 1,
//         orderId: 'D1245',
//         orderDateAndTime: '2026-08-12T10:30:00',
//         userName: 'Mahesh Bonthala',
//         userPhone: '7036646624',
//         vendorRegisteredName: 'Maamaas Houses',
//         riderName: 'Rajesh Kumar',
//         riderPhone: '9876543210',
//         grandTotal: 450.75,
//         status: 'CANCELLED',
//         rejectedBy: 'RIDER',
//         rejectedByName: 'Rajesh Kumar',
//         cancelReason: 'Too far from current location',
//         paymentMethod: 'Online_Payment',
//         deliveryDistanceKm: 5.3
//     },
//     {
//         id: 2,
//         orderId: 'D1246',
//         orderDateAndTime: '2026-08-12T09:15:00',
//         userName: 'Suresh Kumar',
//         userPhone: '8765432109',
//         vendorRegisteredName: 'Spice Garden',
//         riderName: 'Amit Singh',
//         riderPhone: '7654321098',
//         grandTotal: 320.50,
//         status: 'CANCELLED',
//         rejectedBy: 'RIDER',
//         rejectedByName: 'Amit Singh',
//         cancelReason: 'Vehicle breakdown',
//         paymentMethod: 'Maamaas_Wallet',
//         deliveryDistanceKm: 3.1
//     },
//     {
//         id: 3,
//         orderId: 'D1247',
//         orderDateAndTime: '2026-08-11T18:45:00',
//         userName: 'Priya Sharma',
//         userPhone: '6543210987',
//         vendorRegisteredName: 'Taste of Punjab',
//         riderName: 'Vikram Reddy',
//         riderPhone: '5432109876',
//         grandTotal: 280.00,
//         status: 'CANCELLED',
//         rejectedBy: 'RIDER',
//         rejectedByName: 'Vikram Reddy',
//         cancelReason: 'Order already picked up',
//         paymentMethod: 'Online_Payment',
//         deliveryDistanceKm: 2.7
//     },
//     {
//         id: 4,
//         orderId: 'D1248',
//         orderDateAndTime: '2026-08-11T14:20:00',
//         userName: 'Rahul Reddy',
//         userPhone: '4321098765',
//         vendorRegisteredName: 'Coastal Delights',
//         riderName: 'Suresh Babu',
//         riderPhone: '3210987654',
//         grandTotal: 560.25,
//         status: 'CANCELLED',
//         rejectedBy: 'RIDER',
//         rejectedByName: 'Suresh Babu',
//         cancelReason: 'Restaurant closed',
//         paymentMethod: 'Maamaas_Wallet',
//         deliveryDistanceKm: 4.9
//     },
//     {
//         id: 5,
//         orderId: 'D1249',
//         orderDateAndTime: '2026-08-10T12:00:00',
//         userName: 'Ananya Singh',
//         userPhone: '2109876543',
//         vendorRegisteredName: 'Mumbai Mirch',
//         riderName: 'Deepak Gupta',
//         riderPhone: '1098765432',
//         grandTotal: 190.00,
//         status: 'CANCELLED',
//         rejectedBy: 'RIDER',
//         rejectedByName: 'Deepak Gupta',
//         cancelReason: 'Traffic jam',
//         paymentMethod: 'Online_Payment',
//         deliveryDistanceKm: 6.2
//     }
// ];

// // ============================================
// // COMPONENT
// // ============================================
// const DeclinedDeliveryOrders = () => {
//     const navigate = useNavigate();
//     const { showLoader, hideLoader } = useLoader();

//     const [orders, setOrders] = useState([]);
//     const [filteredOrders, setFilteredOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [dateFilter, setDateFilter] = useState('All');
//     const [showDateDropdown, setShowDateDropdown] = useState(false);
//     const [showCustomDateModal, setShowCustomDateModal] = useState(false);
//     const [fromDate, setFromDate] = useState('');
//     const [toDate, setToDate] = useState('');
//     const [refreshing, setRefreshing] = useState(false);

//     // Date filter options
//     const dateOptions = ['All', 'Today', 'Yesterday', 'This Week', 'This Month', 'Custom Range'];

//     // ─── Fetch Orders ──────────────────────────────────────────────
//     useEffect(() => {
//         fetchOrders();
//     }, []);

//     const fetchOrders = async () => {
//         try {
//             setLoading(true);
//             // TODO: Replace with actual API call
//             // const response = await fetch('your-api-endpoint/declined-delivery-orders');
//             // const data = await response.json();

//             // Using dummy data for now
//             setTimeout(() => {
//                 // Filter only RIDER rejected orders
//                 const riderRejectedOrders = dummyOrders.filter(o => o.rejectedBy === 'RIDER');
//                 setOrders(riderRejectedOrders);
//                 setFilteredOrders(riderRejectedOrders);
//                 setLoading(false);
//                 setRefreshing(false);
//             }, 500);
//         } catch (error) {
//             console.error('Error fetching declined delivery orders:', error);
//             setLoading(false);
//             setRefreshing(false);
//         }
//     };

//     // ─── Filter Orders ─────────────────────────────────────────────
//     useEffect(() => {
//         let filtered = [...orders];

//         // Search filter
//         if (searchTerm.trim()) {
//             const term = searchTerm.toLowerCase().trim();
//             filtered = filtered.filter(order =>
//                 order.orderId.toString().includes(term) ||
//                 order.userName.toLowerCase().includes(term) ||
//                 order.vendorRegisteredName.toLowerCase().includes(term) ||
//                 order.riderName.toLowerCase().includes(term)
//             );
//         }

//         // Date filter
//         if (dateFilter !== 'All' && dateFilter !== 'Custom Range') {
//             const today = new Date();
//             today.setHours(0, 0, 0, 0);

//             filtered = filtered.filter(order => {
//                 const orderDate = new Date(order.orderDateAndTime);
//                 orderDate.setHours(0, 0, 0, 0);

//                 switch (dateFilter) {
//                     case 'Today':
//                         return orderDate.getTime() === today.getTime();
//                     case 'Yesterday':
//                         const yesterday = new Date(today);
//                         yesterday.setDate(yesterday.getDate() - 1);
//                         return orderDate.getTime() === yesterday.getTime();
//                     case 'This Week':
//                         const weekStart = new Date(today);
//                         weekStart.setDate(today.getDate() - today.getDay());
//                         return orderDate >= weekStart;
//                     case 'This Month':
//                         return orderDate.getMonth() === today.getMonth() &&
//                             orderDate.getFullYear() === today.getFullYear();
//                     default:
//                         return true;
//                 }
//             });
//         } else if (dateFilter === 'Custom Range' && fromDate && toDate) {
//             const from = new Date(fromDate);
//             const to = new Date(toDate);
//             from.setHours(0, 0, 0, 0);
//             to.setHours(23, 59, 59, 999);

//             filtered = filtered.filter(order => {
//                 const orderDate = new Date(order.orderDateAndTime);
//                 return orderDate >= from && orderDate <= to;
//             });
//         }

//         setFilteredOrders(filtered);
//     }, [searchTerm, dateFilter, fromDate, toDate, orders]);

//     // ─── Stats ─────────────────────────────────────────────────────
//     const totalDeclined = filteredOrders.length;
//     const totalAmount = filteredOrders.reduce((sum, o) => sum + (o.grandTotal || 0), 0);
//     const totalRiders = new Set(filteredOrders.map(o => o.riderName)).size;
//     const avgDistance = filteredOrders.length > 0
//         ? filteredOrders.reduce((sum, o) => sum + (o.deliveryDistanceKm || 0), 0) / filteredOrders.length
//         : 0;

//     // ─── Handle View Order ────────────────────────────────────────
//     const handleViewOrder = (orderId) => {
//         navigate(`/admin/orders/details/${orderId}`);
//     };

//     // ─── Handle Date Filter Select ──────────────────────────────
//     const handleDateSelect = (option) => {
//         if (option === 'Custom Range') {
//             setShowCustomDateModal(true);
//             setShowDateDropdown(false);
//         } else {
//             setDateFilter(option);
//             setShowDateDropdown(false);
//         }
//     };

//     // ─── Apply Custom Range ──────────────────────────────────────
//     const applyCustomRange = () => {
//         if (fromDate && toDate) {
//             setDateFilter('Custom Range');
//             setShowCustomDateModal(false);
//         }
//     };

//     // ─── Get Date Filter Display Text ───────────────────────────
//     const getDateFilterDisplay = () => {
//         if (dateFilter === 'Custom Range' && fromDate && toDate) {
//             return `${fromDate} to ${toDate}`;
//         }
//         return dateFilter;
//     };

//     // ─── Handle Refresh ───────────────────────────────────────────
//     const handleRefresh = () => {
//         setRefreshing(true);
//         fetchOrders();
//     };

//     // ─── Handle Export ────────────────────────────────────────────
//     const handleExport = () => {
//         if (filteredOrders.length === 0) {
//             alert('No data to export.');
//             return;
//         }
//         // TODO: Implement export functionality
//         alert('Export functionality coming soon!');
//     };

//     // ─── Format Date ─────────────────────────────────────────────
//     const formatDate = (dateString) => {
//         if (!dateString) return '-';
//         return new Date(dateString).toLocaleString('en-IN', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//     };

//     // ─── Get Rejected By Badge ───────────────────────────────────
//     const getRejectedByBadge = (rejectedBy, rejectedByName) => {
//         if (rejectedBy === 'RIDER') {
//             return {
//                 label: `🛵 ${rejectedByName || 'Rider'}`,
//                 style: { background: '#dbeafe', color: '#1e40af' }
//             };
//         }
//         return {
//             label: 'Unknown',
//             style: { background: '#f3f4f6', color: '#6b7280' }
//         };
//     };

//     // ─── Render ───────────────────────────────────────────────────
//     return (
//         <div style={styles.container}>
//             {/* ─── Stats Dashboard ─────────────────────────────────── */}
//             <div style={styles.statsGrid}>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Total Declined</div>
//                     <div style={styles.statValue}>{totalDeclined}</div>
//                     <div style={styles.statSub}>Orders rejected by riders</div>
//                 </div>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Total Amount</div>
//                     <div style={styles.statValue} style={{ color: '#16a34a', fontSize: '28px',fontWeight: '700', }}>
//                         ₹{totalAmount.toFixed(2)}
//                     </div>
//                     <div style={styles.statSub}>Total declined amount</div>
//                 </div>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Riders</div>
//                     <div style={styles.statValue} style={{ color: '#2563eb' , fontSize: '28px',fontWeight: '700',}}>{totalRiders}</div>
//                     <div style={styles.statSub}>Unique riders</div>
//                 </div>
//                 <div style={styles.statCard}>
//                     <div style={styles.statLabel}>Avg Distance</div>
//                     <div style={styles.statValue} style={{ color: '#d97706', fontSize: '28px',fontWeight: '700', }}>
//                         {avgDistance.toFixed(1)} km
//                     </div>
//                     <div style={styles.statSub}>Average delivery distance</div>
//                 </div>
//             </div>

//             {/* ─── Filters Bar ────────────────────────────────────── */}
//             <div style={styles.filtersBar}>
//                 {/* Search */}
//                 <div style={styles.searchWrapper}>
//                     <FaSearch color="#94a3b8" size={16} />
//                     <input
//                         type="text"
//                         style={styles.searchInput}
//                         placeholder="Search by Order ID, Customer, Restaurant or Rider..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                 </div>

//                 {/* Date Filter */}
//                 <div style={{ position: 'relative' }}>
//                     <button
//                         style={styles.dateFilterBtn}
//                         onClick={() => setShowDateDropdown(!showDateDropdown)}
//                     >
//                         <FaCalendar color="#e66d33" />
//                         <span>{getDateFilterDisplay()}</span>
//                         <FaChevronDown size={12} color="#94a3b8" />
//                     </button>

//                     {showDateDropdown && (
//                         <div style={styles.dropdown}>
//                             {dateOptions.map(option => (
//                                 <div
//                                     key={option}
//                                     style={{
//                                         ...styles.dropdownItem,
//                                         background: dateFilter === option ? '#fef3e8' : 'white',
//                                         color: dateFilter === option ? '#e66d33' : '#334155'
//                                     }}
//                                     onClick={() => handleDateSelect(option)}
//                                 >
//                                     {option}
//                                 </div>
//                             ))}
//                         </div>
//                     )}
//                 </div>

//                 {/* Action Buttons */}
//                 <button
//                     style={{
//                         ...styles.actionBtn,
//                         background: '#f1f5f9',
//                         color: '#475569'
//                     }}
//                     onClick={() => {
//                         setSearchTerm('');
//                         setDateFilter('All');
//                         setFromDate('');
//                         setToDate('');
//                     }}
//                 >
//                     <FaSync size={14} /> Clear
//                 </button>

//                 <button
//                     style={{
//                         ...styles.actionBtn,
//                         background: '#e66d33',
//                         color: 'white'
//                     }}
//                     onClick={handleRefresh}
//                     disabled={refreshing}
//                 >
//                     <FaSync size={14} /> {refreshing ? 'Refreshing...' : 'Refresh'}
//                 </button>

//                 <button
//                     style={{
//                         ...styles.actionBtn,
//                         background: '#16a34a',
//                         color: 'white'
//                     }}
//                     onClick={handleExport}
//                 >
//                     <FaFileExport size={14} /> Export
//                 </button>
//             </div>

//             {/* ─── Table ───────────────────────────────────────────── */}
//             <div style={styles.tableWrapper}>
//                 {loading ? (
//                     <div style={styles.loadingOverlay}>
//                         <div className="spinner" style={{
//                             width: '40px',
//                             height: '40px',
//                             border: '4px solid #f3f4f6',
//                             borderTop: '4px solid #e66d33',
//                             borderRadius: '50%',
//                             animation: 'spin 1s linear infinite',
//                             margin: '0 auto 12px'
//                         }}></div>
//                         <p>Loading declined delivery orders...</p>
//                     </div>
//                 ) : filteredOrders.length === 0 ? (
//                     <div style={styles.emptyState}>
//                         <div style={{ fontSize: '48px', marginBottom: '12px' }}>🛵</div>
//                         <h3>No Declined Delivery Orders</h3>
//                         <p>There are no delivery orders rejected by riders matching your filters.</p>
//                     </div>
//                 ) : (
//                     <table style={styles.table}>
//                         <thead>
//                             <tr>
//                                 <th style={styles.th}>Order ID</th>
//                                 <th style={styles.th}>Date & Time</th>
//                                 <th style={styles.th}>Customer</th>
//                                 <th style={styles.th}>Restaurant</th>
//                                 <th style={styles.th}>Rider</th>
//                                 <th style={styles.th}>Distance</th>
//                                 <th style={styles.th}>Amount</th>
//                                 <th style={styles.th}>Rejected By</th>
//                                 <th style={styles.th}>Action</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredOrders.map((order) => {
//                                 const rejectedBadge = getRejectedByBadge(order.rejectedBy, order.rejectedByName);
//                                 return (
//                                     <tr key={order.id} style={{ transition: 'background 0.2s ease' }}>
//                                         <td style={styles.td}>
//                                             <strong>#{order.orderId}</strong>
//                                         </td>
//                                         <td style={styles.td}>
//                                             {formatDate(order.orderDateAndTime)}
//                                         </td>
//                                         <td style={styles.td}>
//                                             <div style={{ fontWeight: '500' }}>{order.userName}</div>
//                                             <div style={{ fontSize: '12px', color: '#94a3b8' }}>
//                                                 📞 {order.userPhone || '-'}
//                                             </div>
//                                         </td>
//                                         <td style={styles.td}>
//                                             <div style={{ fontWeight: '500' }}>{order.vendorRegisteredName}</div>
//                                             {order.cancelReason && (
//                                                 <div style={{
//                                                     fontSize: '11px',
//                                                     color: '#94a3b8',
//                                                     maxWidth: '150px',
//                                                     whiteSpace: 'nowrap',
//                                                     overflow: 'hidden',
//                                                     textOverflow: 'ellipsis'
//                                                 }}>
//                                                     Reason: {order.cancelReason}
//                                                 </div>
//                                             )}
//                                         </td>
//                                         <td style={styles.td}>
//                                             <div style={{ fontWeight: '500' }}>{order.riderName}</div>
//                                             <div style={{ fontSize: '12px', color: '#94a3b8' }}>
//                                                 📞 {order.riderPhone || '-'}
//                                             </div>
//                                         </td>
//                                         <td style={styles.td}>
//                                             {order.deliveryDistanceKm ? (
//                                                 <span style={{ fontWeight: '500', color: '#d97706' }}>
//                                                     {order.deliveryDistanceKm.toFixed(1)} km
//                                                 </span>
//                                             ) : '-'}
//                                         </td>
//                                         <td style={styles.td}>
//                                             <span style={{ fontWeight: '600', color: '#16a34a' }}>
//                                                 ₹{order.grandTotal.toFixed(2)}
//                                             </span>
//                                         </td>
//                                         <td style={styles.td}>
//                                             <span style={{
//                                                 ...styles.rejectedByBadge,
//                                                 ...rejectedBadge.style
//                                             }}>
//                                                 {rejectedBadge.label}
//                                             </span>
//                                         </td>
//                                         <td style={styles.td}>
//                                             <button
//                                                 style={styles.viewButton}
//                                                 onClick={() => handleViewOrder(order.orderId)}
//                                             >
//                                                 <FaEye size={14} /> View
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 )}
//             </div>

//             {/* ─── Custom Range Modal ─────────────────────────────── */}
//             {showCustomDateModal && (
//                 <div style={styles.modalOverlay} onClick={() => setShowCustomDateModal(false)}>
//                     <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
//                         <div style={styles.modalHeader}>
//                             <h3 style={styles.modalTitle}>Select Date Range</h3>
//                             <button style={styles.modalClose} onClick={() => setShowCustomDateModal(false)}>
//                                 <MdClose />
//                             </button>
//                         </div>

//                         <div style={styles.modalBody}>
//                             <div style={styles.dateInputGroup}>
//                                 <label style={styles.dateLabel}>From Date</label>
//                                 <input
//                                     type="date"
//                                     style={styles.dateInput}
//                                     value={fromDate}
//                                     onChange={(e) => setFromDate(e.target.value)}
//                                     max={toDate || undefined}
//                                 />
//                             </div>

//                             <div style={styles.dateInputGroup}>
//                                 <label style={styles.dateLabel}>To Date</label>
//                                 <input
//                                     type="date"
//                                     style={styles.dateInput}
//                                     value={toDate}
//                                     onChange={(e) => setToDate(e.target.value)}
//                                     min={fromDate || undefined}
//                                 />
//                             </div>

//                             <button
//                                 style={styles.applyBtn}
//                                 onClick={applyCustomRange}
//                                 disabled={!fromDate || !toDate}
//                             >
//                                 Apply Range
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* ─── Spinner Animation ────────────────────────────────── */}
//             <style>{`
//                 @keyframes spin {
//                     to { transform: rotate(360deg); }
//                 }
//             `}</style>
//         </div>
//     );
// };

// export default DeclinedDeliveryOrders;



import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaSync, FaFileExport, FaCalendar, FaEye, FaChevronDown, FaChevronUp, FaUser, FaPhone, FaIdBadge, FaMapMarkerAlt } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useLoader } from '../../../../context/LoaderProvider';
import adminWebSocketService from '../../../../context/AdminWebSocketService';

// ============================================
// STYLES
// ============================================
const styles = {
    container: {
        margin: '0 auto',
        height: "70vh",
        scrollbarWidth: "none",
        overflow: "auto",
        fontFamily: 'Segoe UI, sans-serif'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        margin: '10px 0px'
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '10px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        transition: 'all 0.3s ease'
    },
    statLabel: {
        fontSize: '13px',
        color: '#94a3b8',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    statValue: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#1e293b'
    },
    statSub: {
        fontSize: '12px',
        color: '#94a3b8',
        marginTop: '4px'
    },
    filtersBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        borderRadius: '12px',
        marginBottom: '10px',
        flexWrap: 'wrap'
    },
    searchWrapper: {
        display: 'flex',
        alignItems: 'center',
        flex: '1',
        minWidth: '200px',
        background: '#f8fafc',
        borderRadius: '8px',
        padding: '0 12px',
        border: '1px solid #e2e8f0',
        transition: 'all 0.2s ease'
    },
    searchInput: {
        border: 'none',
        background: 'transparent',
        padding: '10px 8px',
        fontSize: '14px',
        outline: 'none',
        flex: '1',
        color: '#334155'
    },
    dateFilterBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 16px',
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#334155',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        minWidth: '140px',
        whiteSpace: 'nowrap'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '10px 18px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    tableWrapper: {
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        overflow: 'auto',
        maxHeight: '60vh',
        scrollbarWidth: 'thin'
    },
    emptyState: {
        textAlign: 'center',
        padding: '60px 20px',
        color: '#94a3b8'
    },
    loadingOverlay: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#64748b'
    },
    dropdown: {
        position: 'absolute',
        top: 'calc(100% + 4px)',
        left: 0,
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
        minWidth: '160px',
        overflow: 'hidden',
        zIndex: 100
    },
    dropdownItem: {
        padding: '10px 18px',
        fontSize: '14px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        color: '#334155'
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '20px'
    },
    modalContent: {
        background: 'white',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '480px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
    },
    modalTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1e293b'
    },
    modalClose: {
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#94a3b8',
        padding: '4px'
    },
    dateInputGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
    },
    dateLabel: {
        fontSize: '13px',
        fontWeight: '500',
        color: '#475569'
    },
    dateInput: {
        padding: '10px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        transition: 'all 0.2s ease',
        color: '#334155'
    },
    applyBtn: {
        padding: '12px',
        background: '#e66d33',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        marginTop: '8px'
    },
    orderCard: {
        background: 'white',
        borderRadius: '12px',
        border: '1px solid #f0f0f0',
        marginBottom: '12px',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    orderHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 20px',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    orderInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        flexWrap: 'wrap'
    },
    orderId: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#e66d33'
    },
    orderCount: {
        fontSize: '14px',
        color: '#94a3b8'
    },
    expandedContent: {
        padding: '0 20px 20px 20px',
        background: '#fafbfc',
        borderTop: '1px solid #f0f0f0'
    },
    partnerCard: {
        background: 'white',
        borderRadius: '10px',
        padding: '14px 18px',
        marginTop: '12px',
        border: '1px solid #e8ecf0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'all 0.2s ease',
        flexWrap: 'wrap',
        gap: '12px'
    },
    partnerInfo: {
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
    },
    partnerName: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#1e293b'
    },
    partnerDetail: {
        fontSize: '13px',
        color: '#64748b',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
    },
    rejectionCount: {
        display: 'inline-block',
        padding: '4px 14px',
        background: '#fef3e8',
        color: '#e66d33',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600'
    },
    viewButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 14px',
        background: '#2563eb',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: '500',
        transition: '0.2s'
    }
};

// ============================================
// API URL
// ============================================
const API_URL = "https://backend.maamaas.com/delivery/api/admin/rejected/offers";

// ============================================
// COMPONENT
// ============================================
const DeclinedDeliveryOrders = () => {
    const navigate = useNavigate();
    const { showLoader, hideLoader } = useLoader();

    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [dateFilter, setDateFilter] = useState('All');
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [showCustomDateModal, setShowCustomDateModal] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [refreshing, setRefreshing] = useState(false);
    const [wsMessageCount, setWsMessageCount] = useState(0);

    const dateOptions = ['All', 'Today', 'Yesterday', 'This Week', 'This Month', 'Custom Range'];

    // ─── Fetch Orders ──────────────────────────────────────────────
    const fetchOrders = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("authToken");

            const response = await fetch(API_URL, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch orders: ${response.status}`);
            }

            const data = await response.json();
            //console.log('✅ Fetched declined delivery orders:', data);
            
            const groupedOrders = groupOrdersByOrderId(data);
            setOrders(groupedOrders);
            setFilteredOrders(groupedOrders);
            setLoading(false);
            setRefreshing(false);

        } catch (error) {
            console.error('Error fetching declined delivery orders:', error);
            setLoading(false);
            setRefreshing(false);
        }
    };

    // ─── Group orders by orderId ──────────────────────────────────
    const groupOrdersByOrderId = (data) => {
        const grouped = {};
        data.forEach(item => {
            const orderId = item.orderId;
            if (!grouped[orderId]) {
                grouped[orderId] = {
                    orderId: orderId,
                    appType: item.appType,
                    partners: []
                };
            }
            grouped[orderId].partners.push({
                partnerId: item.partnerId,
                partnerName: item.partnerName,
                phoneNumber: item.phoneNumber,
                latitude: item.latitude,
                longitude: item.longitude,
                locationAddress: item.locationAddress,
                rejectionCount: item.rejectionCount
            });
        });
        return Object.values(grouped);
    };

    // ─── WebSocket Setup ──────────────────────────────────────────
    useEffect(() => {
        //console.log('🚀 DeclinedDeliveryOrders mounted');
        
        const wsStatus = adminWebSocketService.isConnected();
        //console.log(`🔗 WebSocket connection status: ${wsStatus ? '✅ Connected' : '❌ Not connected'}`);

        fetchOrders();

        const handleWebSocketMessage = (event) => {
            //console.log('📨 WEBSOCKET MESSAGE RECEIVED!');
            setWsMessageCount(prev => prev + 1);
            
            //console.log('📋 Topic:', event.detail.topic);
            //console.log('📦 Data:', event.detail.data);
            
            if (event.detail.topic === 'delivery-rejected-offer') {
                const newData = event.detail.data;
                
                if (Array.isArray(newData)) {
                    //console.log(`📦 Received ${newData.length} rejected offers from WebSocket`);
                    setOrders(prevOrders => {
                        const combined = [...prevOrders, ...newData];
                        return groupOrdersByOrderId(combined);
                    });
                } else if (newData && typeof newData === 'object') {
                    //console.log('📦 Received single rejected offer from WebSocket');
                    setOrders(prevOrders => {
                        const combined = [...prevOrders, newData];
                        return groupOrdersByOrderId(combined);
                    });
                } else {
                    console.warn('⚠️ Unknown data format:', newData);
                }
            }
        };

        window.addEventListener('admin-websocket-message', handleWebSocketMessage);

        return () => {
            //console.log('🧹 Cleaning up WebSocket listener...');
            window.removeEventListener('admin-websocket-message', handleWebSocketMessage);
        };
    }, []);

    // ─── Filter Orders ─────────────────────────────────────────────
    useEffect(() => {
        let filtered = [...orders];

        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase().trim();
            filtered = filtered.filter(order =>
                order.orderId.toString().includes(term) ||
                order.partners.some(p => 
                    p.partnerName.toLowerCase().includes(term) ||
                    p.partnerId.toString().includes(term) ||
                    p.phoneNumber.includes(term)
                )
            );
        }

        setFilteredOrders(filtered);
    }, [searchTerm, orders]);

    // ─── Stats ─────────────────────────────────────────────────────
    const totalOrders = filteredOrders.length;
    const totalPartners = filteredOrders.reduce((sum, order) => sum + order.partners.length, 0);
    const totalRejections = filteredOrders.reduce((sum, order) => 
        sum + order.partners.reduce((s, p) => s + (p.rejectionCount || 0), 0), 0
    );
    const avgRejections = totalOrders > 0 ? (totalRejections / totalOrders).toFixed(1) : '0.0';

    // ─── Toggle Expand ────────────────────────────────────────────
    const toggleExpand = (orderId) => {
        setExpandedOrder(expandedOrder === orderId ? null : orderId);
    };

    // ─── Handle View Order ────────────────────────────────────────
    const handleViewOrder = (orderId) => {
        navigate(`/admin/orders/details/${orderId}`);
    };

    // ─── Handle Date Filter Select ──────────────────────────────
    const handleDateSelect = (option) => {
        if (option === 'Custom Range') {
            setShowCustomDateModal(true);
            setShowDateDropdown(false);
        } else {
            setDateFilter(option);
            setShowDateDropdown(false);
        }
    };

    // ─── Apply Custom Range ──────────────────────────────────────
    const applyCustomRange = () => {
        if (fromDate && toDate) {
            setDateFilter('Custom Range');
            setShowCustomDateModal(false);
        }
    };

    // ─── Get Date Filter Display Text ───────────────────────────
    const getDateFilterDisplay = () => {
        if (dateFilter === 'Custom Range' && fromDate && toDate) {
            return `${fromDate} to ${toDate}`;
        }
        return dateFilter;
    };

    // ─── Handle Refresh ───────────────────────────────────────────
    const handleRefresh = () => {
        setRefreshing(true);
        fetchOrders();
    };

    // ─── EXPORT FUNCTIONALITY ──────────────────────────────────────
    const handleExport = () => {
        if (filteredOrders.length === 0) {
            alert('No data to export.');
            return;
        }

        try {
            // Prepare CSV data
            const csvRows = [];
            
            // Add headers
            const headers = [
                'Order ID',
                'App Type',
                'Partner ID',
                'Partner Name',
                'Phone Number',
                'Rejection Count',
                'Latitude',
                'Longitude',
                'Location Address'
            ];
            csvRows.push(headers.join(','));

            // Add data rows
            filteredOrders.forEach(order => {
                order.partners.forEach(partner => {
                    const row = [
                        order.orderId,
                        order.appType || '',
                        partner.partnerId || '',
                        `"${partner.partnerName || ''}"`,
                        partner.phoneNumber || '',
                        partner.rejectionCount || 0,
                        partner.latitude || '',
                        partner.longitude || '',
                        `"${partner.locationAddress || ''}"`
                    ];
                    csvRows.push(row.join(','));
                });
            });

            // Create CSV string
            const csvString = csvRows.join('\n');
            
            // Create blob and download
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', `declined_delivery_orders_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            alert('✅ Export successful!');
        } catch (error) {
            console.error('Export error:', error);
            alert('Failed to export data. Please try again.');
        }
    };

    // ─── Format Date ─────────────────────────────────────────────
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // ─── Render ───────────────────────────────────────────────────
    return (
        <div style={styles.container}>
            {/* ─── Stats Dashboard ─────────────────────────────────── */}
            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Orders</div>
                    <div style={styles.statValue}>{totalOrders}</div>
                    <div style={styles.statSub}>Orders with rejections</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Partners</div>
                    <div style={{ color: '#2563eb', fontSize: '28px', fontWeight: '700' }}>
                        {totalPartners}
                    </div>
                    <div style={styles.statSub}>Unique partner rejections</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Total Rejections</div>
                    <div  style={{ color: '#dc2626', fontSize: '28px', fontWeight: '700' }}>
                        {totalRejections}
                    </div>
                    <div style={styles.statSub}>Total rejection count</div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statLabel}>Avg Rejections/Order</div>
                    <div  style={{ color: '#d97706', fontSize: '28px', fontWeight: '700' }}>
                        {avgRejections}
                    </div>
                    <div style={styles.statSub}>Average per order</div>
                </div>
            </div>

            {/* ─── Filters Bar ────────────────────────────────────── */}
            <div style={styles.filtersBar}>
                <div style={styles.searchWrapper}>
                    <FaSearch color="#94a3b8" size={16} />
                    <input
                        type="text"
                        style={styles.searchInput}
                        placeholder="Search by Order ID, Partner Name, Phone..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div style={{ position: 'relative' }}>
                    <button
                        style={styles.dateFilterBtn}
                        onClick={() => setShowDateDropdown(!showDateDropdown)}
                    >
                        <FaCalendar color="#e66d33" />
                        <span>{getDateFilterDisplay()}</span>
                        <FaChevronDown size={12} color="#94a3b8" />
                    </button>

                    {showDateDropdown && (
                        <div style={styles.dropdown}>
                            {dateOptions.map(option => (
                                <div
                                    key={option}
                                    style={{
                                        ...styles.dropdownItem,
                                        background: dateFilter === option ? '#fef3e8' : 'white',
                                        color: dateFilter === option ? '#e66d33' : '#334155'
                                    }}
                                    onClick={() => handleDateSelect(option)}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

             

                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#e66d33',
                        color: 'white'
                    }}
                    onClick={handleRefresh}
                    disabled={refreshing}
                >
                    <FaSync size={14} /> {refreshing ? 'Refreshing...' : 'Refresh'}
                </button>

                <button
                    style={{
                        ...styles.actionBtn,
                        background: '#16a34a',
                        color: 'white'
                    }}
                    onClick={handleExport}
                >
                    <FaFileExport size={14} /> Export
                </button>

                <span style={{
                    fontSize: '12px',
                    color: adminWebSocketService.isConnected() ? '#16a34a' : '#dc2626',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    marginLeft: 'auto'
                }}>
                    <span style={{
                        display: 'inline-block',
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: adminWebSocketService.isConnected() ? '#22c55e' : '#ef4444'
                    }}></span>
                    {adminWebSocketService.isConnected() ? 'Live' : 'Offline'}
        
                </span>
            </div>

            {/* ─── Order Cards ────────────────────────────────────── */}
            <div style={styles.tableWrapper}>
                {loading ? (
                    <div style={styles.loadingOverlay}>
                        <div className="spinner" style={{
                            width: '40px',
                            height: '40px',
                            border: '4px solid #f3f4f6',
                            borderTop: '4px solid #e66d33',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                            margin: '0 auto 12px'
                        }}></div>
                        <p>Loading declined delivery orders...</p>
                    </div>
                ) : filteredOrders.length === 0 ? (
                    <div style={styles.emptyState}>
                        <div style={{ fontSize: '48px', marginBottom: '12px' }}>🛵</div>
                        <h3>No Declined Delivery Orders</h3>
                        <p>There are no delivery orders rejected by riders.</p>
                    </div>
                ) : (
                    filteredOrders.map((order) => (
                        <div key={order.orderId} style={styles.orderCard}>
                            {/* Order Header */}
                            <div
                                style={{
                                    ...styles.orderHeader,
                                    borderBottom: expandedOrder === order.orderId ? '1px solid #f0f0f0' : '1px solid transparent',
                                    background: expandedOrder === order.orderId ? '#fafbfc' : 'white'
                                }}
                                onClick={() => toggleExpand(order.orderId)}
                            >
                                <div style={styles.orderInfo}>
                                    <div style={styles.orderId}>Order #{order.orderId}</div>
                                    <div style={styles.orderCount}>
                                        {order.partners.length} partner{order.partners.length > 1 ? 's' : ''} rejected
                                    </div>
                                    {order.appType && (
                                        <span style={{
                                            fontSize: '11px',
                                            padding: '2px 10px',
                                            borderRadius: '12px',
                                            background: '#e8f0fe',
                                            color: '#1a73e8'
                                        }}>
                                            {order.appType}
                                        </span>
                                    )}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <span style={{
                                        fontSize: '13px',
                                        color: '#94a3b8'
                                    }}>
                                        Total Rejections: {order.partners.reduce((s, p) => s + (p.rejectionCount || 0), 0)}
                                    </span>
                                    {expandedOrder === order.orderId ? (
                                        <FaChevronUp color="#94a3b8" />
                                    ) : (
                                        <FaChevronDown color="#94a3b8" />
                                    )}
                                </div>
                            </div>

                            {/* Expanded Content - Partner Cards */}
                            {expandedOrder === order.orderId && (
                                <div style={styles.expandedContent}>
                                    {order.partners.map((partner, index) => (
                                        <div key={index} style={styles.partnerCard}>
                                            <div style={styles.partnerInfo}>
                                                <div style={styles.partnerName}>
                                                    <FaUser size={14} style={{ marginRight: '8px', color: '#64748b' }} />
                                                    {partner.partnerName || `Partner ${partner.partnerId}`}
                                                </div>
                                                <div style={styles.partnerDetail}>
                                                    <FaIdBadge size={12} /> ID: {partner.partnerId}
                                                </div>
                                                <div style={styles.partnerDetail}>
                                                    <FaPhone size={12} /> {partner.phoneNumber || 'N/A'}
                                                </div>
                                                
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                                <span style={styles.rejectionCount}>
                                                    Rejected {partner.rejectionCount || 0} time{partner.rejectionCount > 1 ? 's' : ''}
                                                </span>
                                                <button
                                                    style={styles.viewButton}
                                                    onClick={() => handleViewOrder(order.orderId)}
                                                >
                                                    <FaEye size={14} /> View Order
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>

            {/* ─── Custom Range Modal ─────────────────────────────── */}
            {showCustomDateModal && (
                <div style={styles.modalOverlay} onClick={() => setShowCustomDateModal(false)}>
                    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>Select Date Range</h3>
                            <button style={styles.modalClose} onClick={() => setShowCustomDateModal(false)}>
                                <MdClose />
                            </button>
                        </div>

                        <div style={styles.modalBody}>
                            <div style={styles.dateInputGroup}>
                                <label style={styles.dateLabel}>From Date</label>
                                <input
                                    type="date"
                                    style={styles.dateInput}
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    max={toDate || undefined}
                                />
                            </div>

                            <div style={styles.dateInputGroup}>
                                <label style={styles.dateLabel}>To Date</label>
                                <input
                                    type="date"
                                    style={styles.dateInput}
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    min={fromDate || undefined}
                                />
                            </div>

                            <button
                                style={styles.applyBtn}
                                onClick={applyCustomRange}
                                disabled={!fromDate || !toDate}
                            >
                                Apply Range
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ─── Spinner Animation ────────────────────────────────── */}
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default DeclinedDeliveryOrders;